import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { useSortAndFilter } from "../contexts/SortAndFilterContext";
import { StyledDiv } from "./styles";
import { messages } from "./messages";

export const ClearAllButton = (): JSX.Element => {
  const intl = useIntl();
  const sortAndFilterContext = useSortAndFilter();

  const handleOnClick = useCallback(() => {
    sortAndFilterContext.clearAll();
  }, [sortAndFilterContext]);

  return (
    <StyledDiv onClick={handleOnClick} role="clearAll">
      {intl.formatMessage(messages.clearAll)}
    </StyledDiv>
  );
};
